import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobecreativecloudComponent } from './simple-icons-adobecreativecloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobecreativecloudComponent ],
    exports:      [ SimpleIconsAdobecreativecloudComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobecreativecloudModule {}
